// extracted by mini-css-extract-plugin
export default {"Title":"Validation_Title__nYi42","Pagination":"Validation_Pagination__MySxM"};